import { render, staticRenderFns } from "./VehicleInspectionData.vue?vue&type=template&id=5575dc32&scoped=true&"
import script from "./VehicleInspectionData.vue?vue&type=script&lang=ts&"
export * from "./VehicleInspectionData.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleInspectionData.vue?vue&type=style&index=0&id=5575dc32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575dc32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VContainer,VRow})
